import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text, Button as BaseButton } from '@leroy-merlin-br/backyard-react-ui'

const contentStyles = ({ theme }) => css`
  label: footer;

  position: relative;

  padding: ${theme.spacings.mega} ${theme.spacings.giga};

  background: ${theme.colors.white};
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.2);

  ${theme.media.mega} {
    box-shadow: none;
    background: transparent;
  }
`

const buttonActiveStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    label: footer__button--active;

    color: ${theme.colors.v700};
    background: ${theme.colors.white};
    pointer-events: none;

    ${theme.media.mega} {
      color: ${theme.colors.white};
      background: ${theme.colors.v700};
    }
  `

const textFooterStyles = ({ theme }) => css`
  color: ${theme.colors.n600};
`

export const TextFooter = styled(Text)(textFooterStyles)
export const ButtonSend = styled(BaseButton)(buttonActiveStyles)

const contentActiveStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    label: footer__content--active;

    ${theme.media.mega} {
      ${TextFooter} {
        color: ${theme.colors.f300};
      }
    }
  `
export const Content = styled('div')(contentStyles, contentActiveStyles)
